import React, { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      setJustReconnected(true);
      setTimeout(() => setJustReconnected(false), 3500);
    };
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online && !justReconnected) return null;

  return (
    <div
      data-testid="offline-indicator"
      className={`fixed left-1/2 -translate-x-1/2 top-3 z-50 px-4 py-2 rounded-full text-xs font-medium shadow-xl backdrop-blur border ${
        online
          ? "bg-emerald-500/15 text-emerald-200 border-emerald-500/30"
          : "bg-rose-500/15 text-rose-200 border-rose-500/30"
      } flex items-center gap-2 animate-fade-up`}
    >
      {online ? <Wifi className="w-3.5 h-3.5" /> : <WifiOff className="w-3.5 h-3.5" />}
      {online ? "Back online — syncing fresh data" : "Offline · showing cached cosmic data"}
    </div>
  );
}
